
$(document).ready(function () {
	$(".anker").click(function () {
		var t; return t = $($(this).attr("href")), 0 != t.length ? ($("html, body").animate({
			scrollTop: t.offset().top - $("#header").outerHeight()
		}), !1) : void 0
	})
});
